import { OnInit, OnDestroy, Component, HostListener, Optional, Inject } from '@angular/core';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';
import { ActivatedRoute } from '@angular/router';

declare let dojoApp: any;

@Component({
    selector: 'dojo-rtquote-toggle',
    templateUrl: './dojo-rtquote-toggle.component.html'
})
export class DojoRtQuoteToggleComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    isMyclientView: boolean;
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private route: ActivatedRoute,
                @Optional() @Inject('AppSettings') appSettings: any) {
        this.isMyclientView = appSettings.isAdvisor;
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.getRtQuoteToggle();
        });
    }

    ngOnDestroy(): void {
        console.log('In dojo RealalTime Quote Toggle method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyRtQuoteToggle();
        }
    }
    renderDojoWidget(rtQuoteToggleDojoParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            rtQuoteToggleDojoParams.isAdvisor = this.isMyclientView;
            dojoApp.renderRtQuoteToggle(this.inputValue, rtQuoteToggleDojoParams);
        }
    }
    getRtQuoteToggle() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.nxiWidgetParamsService.getWidgetParamsForMixin('realTimeQuoteToggle').subscribe(
                resp => {
                    console.log('Retrived common Real params : ', resp.response);
                    if (resp.response) {
                        if (resp.response.hasAgreed) {
                            this.route.queryParams.subscribe(
                                params => {
                                    if (params.rt != null) {
                                        sessionStorage.setItem('realTimeActive', params.rt);
                                    }
                                }
                            );
                        }
                        // resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
                        this.renderDojoWidget(resp.response);
                    }
                }
            );
        }
    }
    // used to handle click event on submit button
    @HostListener('click', ['$event.target'])
    onClick(btn) {
        console.log('button', btn);
    }
}
